module.exports = __webpack_public_path__ + "img/voiceOverIcon.2135a014.svg";